import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';


@Component({
  selector: 'app-partner-performance-incentive-field',
  templateUrl: './partner-performance-incentive-field.component.html',
  styleUrls: ['./partner-performance-incentive-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PartnerPerformanceIncentiveFieldComponent implements OnInit {
  @Input('required') isRequired = false;

  form: FormGroup;

  constructor(private ctrlContainer: FormGroupDirective){};

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    if (this.isRequired) {
      this.form.addControl('incentive', new FormControl(null, Validators.required));
    } else {
      this.form.addControl('incentive', new FormControl(null));
    }
  }

  ngOnDestroy(): void {
    this.form.removeControl('incentive');
  }

}
